export const IconSearch = ({ style, className }) => {
  // style={style}
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.3307 29C7.7974 29 1.66406 22.8667 1.66406 15.3333C1.66406 7.8 7.7974 1.66667 15.3307 1.66667C22.8641 1.66667 28.9974 7.8 28.9974 15.3333C28.9974 22.8667 22.8641 29 15.3307 29ZM15.3307 3.66667C8.89073 3.66667 3.66406 8.90667 3.66406 15.3333C3.66406 21.76 8.89073 27 15.3307 27C21.7707 27 26.9974 21.76 26.9974 15.3333C26.9974 8.90667 21.7707 3.66667 15.3307 3.66667Z" fill="white"/>
      <path d="M29.3352 30.3333C29.0819 30.3333 28.8285 30.24 28.6285 30.04L25.9619 27.3733C25.5752 26.9867 25.5752 26.3467 25.9619 25.96C26.3485 25.5733 26.9885 25.5733 27.3752 25.96L30.0419 28.6267C30.4285 29.0133 30.4285 29.6533 30.0419 30.04C29.8419 30.24 29.5885 30.3333 29.3352 30.3333Z" fill="white"/>
    </svg>
  );
};
